import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

/**
 * Tailwind chip/pill — replaces MUI Chip.
 * color: 'default' | 'success' | 'warning' | 'error' | 'info' | 'primary'
 */
const COLORS = {
  default: 'bg-slate-100 text-slate-700',
  primary: 'bg-[#e8f1fb] text-[#0061B2] border border-[#0061B2]/30',
  success: 'bg-emerald-50 text-emerald-700',
  warning: 'bg-amber-50 text-amber-700',
  error: 'bg-red-50 text-red-700',
  info: 'bg-blue-50 text-blue-700',
};

const Chip = ({ label, children, color = 'default', size = 'sm', onDelete, className = '', ...rest }) => (
  <span
    className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full font-medium ${
      size === 'xs' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-0.5 text-xs'
    } ${COLORS[color] || COLORS.default} ${className}`}
    {...rest}
  >
    {label ?? children}
    {onDelete && (
      <button
        type="button"
        onClick={onDelete}
        aria-label="Remove"
        className="-mr-1 rounded-full p-0.5 hover:bg-black/10"
      >
        <XMarkIcon className="h-3 w-3" />
      </button>
    )}
  </span>
);

export default Chip;
